import { render, staticRenderFns } from "./editMoreEffective.vue?vue&type=template&id=35ee6111&scoped=true"
import script from "./editMoreEffective.vue?vue&type=script&lang=js"
export * from "./editMoreEffective.vue?vue&type=script&lang=js"
import style0 from "./editMoreEffective.vue?vue&type=style&index=0&id=35ee6111&prod&scoped=true&lang=scss"
import style1 from "./editMoreEffective.vue?vue&type=style&index=1&id=35ee6111&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee6111",
  null
  
)

export default component.exports